import type { LoaderFunctionArgs } from '@remix-run/node'
import { Link, Outlet } from '@remix-run/react'
import { json, redirect } from '@remix-run/node'
import { authenticator } from '#app/modules/auth/auth.server'
import { getDomainPathname } from '#app/utils/misc.server'
import { ROUTE_PATH as LOGIN_PATH } from '#app/routes/auth+/login'
import { ROUTE_PATH as DASHBOARD_PATH } from '#app/routes/dashboard+/_layout'
import { useEffect } from 'react'
import { useState } from 'react'

export const ROUTE_PATH = '/auth' as const

export async function loader({ request }: LoaderFunctionArgs) {
  await authenticator.isAuthenticated(request, {
    successRedirect: DASHBOARD_PATH,
  })
  const pathname = getDomainPathname(request)
  if (pathname === ROUTE_PATH) return redirect(LOGIN_PATH)
  return json({})
}

const QUOTES = [
  {
    quote: 'There is nothing impossible to they who will try.',
    author: 'Alexander the Great',
  },
  {
    quote: 'The only way to do great work is to love what you do.',
    author: 'Steve Jobs',
  },
  {
    quote: 'The best way to predict the future is to create it.',
    author: 'Peter Drucker',
  },
  {
    quote: 'The only limit to our realization of tomorrow will be our doubts of today.',
    author: 'Franklin D. Roosevelt',
  },
  {
    quote: 'The only thing we have to fear is fear itself.',
    author: 'Franklin D. Roosevelt',
  },
]

export default function Layout() {
  const randomQuote = QUOTES[Math.floor(Math.random() * QUOTES.length)]


  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768); // You can adjust this breakpoint
    };

    // Check on initial load
    checkMobile();

    // Check when window is resized
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return (
      <div className="fixed inset-3 flex items-center justify-center bg-gray-900 text-white p-6">
        <div className="text-center m-6">
          <h1 className="text-2xl font-bold mb-4 text-darkBlue">
            Desktop Required
          </h1>
          <p className="text-lg text-darkBlue">
            Please use a computer to access NeighborCloud. 
            This application is not optimized for mobile devices.
            <br />
            <br />
            A mobile app is coming later in 2025.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-row w-full min-h-screen">
      <div className="flex flex-col text-white bg-darkBlue min-w-96">
        <div className="flex flex-col p-[100px]">
          <h2 className="text-6xl font-semibold leading-tight mb-4 whitespace-nowrap text-[length:var(--dynamic-text-size,4rem)]">
            Neighborhood<br />Management<br />Made Simple
          </h2>
          <p className="text-lg whitespace-nowrap text-[length:var(--dynamic-text-size,1.125rem)]">
            NeighborCloud gives you the freedom and flexibility<br />to efficiently manage your neighborhoods.
          </p>
        </div>
        <div className="flex flex-col flex-1 px-[100px] pb-10 justify-end">
          <h2 className="text-9xl font-semibold text-warning">⋆⋆⋆⋆⋆</h2>
          <p className="text-lg whitespace-nowrap text-[length:var(--dynamic-text-size,1.125rem)]">
            "NeighborCloud makes it easy,<br />to manage our neighborhoods.<br />Their expertise, coupled with,<br />a simple interface makes<br />this platform the absolute best."
          </p>
          <div className="flex flex-row pt-6 items-center">
            <div className="bg-blue rounded-full p-1 mr-3 inline-block">
              <img src="/images/simon.jpg" alt="Simon Keller" className="w-16 h-16 rounded-full" />
            </div>
            <div className="flex flex-col">
              <p className="whitespace-nowrap"><b>Simon Keller</b></p>
              <p className="whitespace-nowrap">Board Member, Green Valley HOA</p>
            </div>
          </div>
        </div>
			</div>
      <div className="flex h-full w-full flex-col border-l border-primary/5 bg-card lg:w-[50%]">
        <Outlet />
      </div>
    </div>
  )
}
